import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

@Injectable()
export class ResponseHandlerInterceptorInterceptor implements HttpInterceptor {

  private cache: any = [];

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the request method is GET
   

    // Generate a unique cache key based on the request URL
    const cacheKey = req.urlWithParams;

    // Check if the response is cached
    if (this.cache.includes(cacheKey)) {
      return EMPTY; // Return the cached response
    }else{
      this.cache.push(cacheKey)
      next.handle(req)
    }

    // If not cached, make the request and cache the response
    const response$ = next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          // Cache the response
         this.cache = this.cache.filter(el=> !(el.includes(cacheKey)) )
        }
      },(err)=>{
        this.cache = this.cache.filter(el=> !(el.includes(cacheKey)) )
        console.log(err,"Err");
        
      }),
      shareReplay(1) // Share the response among multiple subscribers
    );

    return response$;
  }
}
